<template>
<div>
    <md-dialog-content>
        <p>Collaborators</p>
        <md-list class="md-double-line">
            <md-list-item v-if="owner">
                <md-avatar>
                    <img :src="owner.profile_picture"/>
                </md-avatar>
                <div class="md-list-text-container">
                    <span>{{owner.username}}</span>
                    <span>Project Owner</span>
                </div>
            </md-list-item>
            <collaborator v-for="collab in project.collaborators"
                :user="userByUID(collab.uid)"
                :collaborator="collab" 
                :key="collab.uid" 
                @removeCollaborator="removeCollaborator" 
            />
            <invite :project="project" @addCollaborator="addCollaborator"/>
        </md-list>
<!--         <br/>
        <md-layout class="heading-align" md-align="center" >
            <md-layout md-flex="90">
                <h2 class="md-title">Invite a Collaborator</h2>
            </md-layout>
        </md-layout> -->
        
    </md-dialog-content>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CollaboratorsCollaborator from '@/components/collaborators/collaborator';
import CollaboratorsInvite from '@/components/collaborators/invite';

const Collaborators = {
    name: 'collaborators',
    props: ['project'],
    computed: {
        ...mapGetters([
            'user',
            'userByUID'
        ]),
        owner() {
            return this.user;
        }
    },
    methods: {
        addCollaborator(collab) {
            this.project.collaborators.unshift(collab);
        },
        removeCollaborator(collab) {
            const index = this.project.collaborators.findIndex((c) => {
                return c.uid === collab.uid;
            });
            this.project.collaborators.splice(index, 1);
        }
    },
    components: {
        collaborator: CollaboratorsCollaborator,
        invite: CollaboratorsInvite
    }
};
export default Collaborators;
</script>

<style>
.md-dialog {
    overflow-y: scroll;
}

</style>


// WEBPACK FOOTER //
// collaborators.vue?84dde9aa